// Copyright (c) 2016 Deere & Company

import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-maintenance-plan';
import {
    findMatchingAccount,
    findMatchingKey,
    findMatchingPlan
} from '../../../shared/services/claim-shared-helper';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const addFile = (state, action) =>
    Claim.update(state, {
        file: {
            $push: [action.data]
        }
    });

const copyClaim = state => {

    const defaultClaim = getClaimDefaultState();

    return Claim.update(state, {
        $merge: {
            allowedActions: [
                new ClaimAction({
                    actionName: 'DRAFT',
                    id: 'DRAFT',
                    mode: 'CHG'
                }),
                new ClaimAction({
                    actionName: 'SAVE_VALD',
                    id: 'SAVE_VALD',
                    mode: 'CHG'
                })
            ],
            claimNumber: defaultClaim.claimNumber,
            claimStatus: defaultClaim.claimStatus,
            claimValueDetails: defaultClaim.claimValueDetails,
            errors: defaultClaim.errors,
            recordInfo: defaultClaim.recordInfo,
            reimbursementDetails: defaultClaim.reimbursementDetails
        }
    });

};

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.serialNumber === action.data.serialNumber && file.name === action.data.name);

    return Claim.update(state, {
        file: {
            $splice: [[index, 1]]
        }
    });

};

const updateFile = (state, action) =>
    Claim.update(state, {
        file: {
            $set: action.files
        }
    });

const resetClaim = () =>
    getClaimDefaultState();

const updateClaim = (state, action) =>
    Claim.update(state, {
        $set: action.updatedClaim
    });

const updateComments = (state, action) =>
    Claim.update(state, {
        comments: {
            $set: action.comments
        }
    });

const updateMachineType = (state, action) =>
    Claim.update(state, {
        machineType: {
            $set: action.data
        }
    });

const updateNoTravel = (state, action) =>
    Claim.update(state, {
        noTravel: {
            $set: action.data
        }
    });

const updateServiceInterval = (state, action) =>
    Claim.update(state, {
        serviceInterval: {
            $set: action.data
        }
    });

const resetUseAmount = state =>
    Claim.update(state, {
        useAmount: {
            $set: getDefaultState().claim.useAmount
        }
    });

const updateAdditionalComments = (state, action) =>
    Claim.update(state, {
        additionalComments: {
            $set: action.additionalComments
        }
    });

const updateGoodsInstallationVat = (state, action) =>
    Claim.update(state, {
        goodsInstallationVat: {
            $set: action.goodsInstallationVat
        }
    });

const updatePin = (state, action) =>
    Claim.update(state, {
        pin: {
            $set: action.pin
        }
    });

const updatePlanName = (state, action) => {

    const selectedPlan = findMatchingPlan(action.planName, action.plans);

    return Claim.update(state, {
        planName: {
            key: {
                $set: selectedPlan.planName
            },
            value: {
                $set: selectedPlan.planDescription
            }
        }
    });

};

const updateRepairNumber = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            repairNumber: {
                $set: action.repairNumber
            }
        }
    });

const updateResponsibleAccount = (state, action) =>
    Claim.update(state, {
        responsibleAccount: {
            $set: findMatchingAccount(action.accountId, action.dealers)
        }
    });

const updateServiceDate = (state, action) =>
    Claim.update(state, {
        serviceDate: {
            $set: action.date
        }
    });

const updateUseAmount = (state, action) =>
    Claim.update(state, {
        useAmount: {
            amount: {
                $set: action.amount
            }
        }
    });

const updateUseAmountUnit = (state, action) =>
    Claim.update(state, {
        useAmount: {
            unit: {
                $set: findMatchingKey(action.key, action.allowedUnits)
            }
        }
    });

const updateWorkOrderOne = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            referenceNumber1: {
                $set: action.workOrderOne
            }
        }
    });

const updateWorkOrderTwo = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            referenceNumber2: {
                $set: action.workOrderTwo
            }
        }
    });

const reviseClaim = state =>
    Claim.update(state, {
        errors: {
            $set: []
        }
    });

export default (state = getDefaultState().claim, action) => {

    const actionTypes = {
        [actions.ADD_CLAIM_MAINTENANCE_PLAN_FILE]: addFile,
        [actions.COPY_CLAIM_MAINTENANCE_PLAN]: copyClaim,
        [actions.DELETE_CLAIM_MAINTENANCE_PLAN_FILE]: deleteFile,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetClaim,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_ADDITIONAL_COMMENTS]: updateAdditionalComments,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_COMMENTS]: updateComments,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_MACHINE_TYPE]: updateMachineType,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_NO_TRAVEL]: updateNoTravel,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_SERVICE_INTERVAL]: updateServiceInterval,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT]: resetUseAmount,
        [actions.REVISE_CLAIM_MAINTENANCE_PLAN]: reviseClaim,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_ADDITIONAL_COMMENTS]: updateAdditionalComments,
        [actions.SET_CLAIM_MAINTENANCE_PLAN]: updateClaim,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_COMMENTS]: updateComments,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_FILE]: updateFile,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_GOODS_INSTALLATION_VAT]: updateGoodsInstallationVat,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_MACHINE_TYPE]: updateMachineType,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_NO_TRAVEL]: updateNoTravel,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_PIN]: updatePin,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SELECTED_OPEN_MAINTENANCE_PLAN]: updatePlanName,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_REPAIR_NUMBER]: updateRepairNumber,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_RESPONSIBLE_ACCOUNT]: updateResponsibleAccount,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SERVICE_DATE]: updateServiceDate,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SERVICE_INTERVAL]: updateServiceInterval,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT]: updateUseAmount,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT_UNIT]: updateUseAmountUnit,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_WORK_ORDER_ONE]: updateWorkOrderOne,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_WORK_ORDER_TWO]: updateWorkOrderTwo
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/claim.js